import angular from 'angular';

/**
 * @memberOf cms.input.select
 * @property {object}      bindings.errors     Form errors object
 * @property {object|text} bindings.model      Input value reference
 * @property {string}      bindings.title      Input title and/or placeholder
 * @property {array}       bindings.options    Select options
 * @property {boolean}     bindings.multiple   Multi or single select
 *
 * @todo More flexible data operations in ui-select-choices
 */
let cmsInputSelect = {
    bindings: {
        errors: '<',
        model: '=',
        label: '@',
        helper: '@',
        options: '<',
        multiple: '<',
        aclShow: '<?',
        aclDisable: '<?',
        labelSize: '@',
        inputSize: '@'
    },
    template: require('./select.html')
};

/**
 * Select control using ui-select
 * @namespace cms.input.select
 * @see https://angular-ui.github.io/ui-select
 */
export default angular.module('cms.input.select', []).component('cmsInputSelect', cmsInputSelect).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Controls/SelectControl/CmsInputSelect.js